import React, { useState } from "react";
import { Layout } from "components/Layout/Layout";
import { Alert, Button } from "@mui/material";
import { TextFieldWrapper } from "components/Wrappers/FormComponentsWrappers/TextFieldWrapper";
import { message } from "constants/responses/message";
import { resetPasswordApi } from "API/apis/auth/resetPassword";
import { useGlobalContext } from "context/GlobalContext";
import { useNavigate } from "react-router-dom";
import { routeLinks } from "constants/paths";
const initialValue = {
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
};
export const ResetPasswordPage = () => {
  const [formData, setFormData] = useState(initialValue);
  const [formError, setFormError] = useState("");
  const { setSuccess } = useGlobalContext();

  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (formData.confirmPassword !== formData.newPassword) {
        throw new Error(message.error.confirmPasswordMismatch);
      }
      const { data, status } = await resetPasswordApi(formData);
      if (status !== 200) {
        throw new Error(data.message);
      } else {
        setSuccess(data.message);
        navigate(routeLinks.dashboardCommon);
      }
    } catch (error) {
      setFormError(error.message);
    }
  };
  const handleChange = (event) => {
    if (formData) {
      setFormData({
        ...formData,
        [event.target.name]: event.target.value,
      });
    }
  };
  return (
    <Layout>
      <form onSubmit={handleSubmit}>
        {formError && <Alert severity="error">{formError}</Alert>}
        <TextFieldWrapper
          id="oldPassword"
          name="oldPassword"
          label="Old Password"
          variant="outlined"
          type="password"
          value={formData.oldPassword}
          fullWidth
          required
          onChange={handleChange}
        />
        <TextFieldWrapper
          id="newPassword"
          name="newPassword"
          label="New Password"
          variant="outlined"
          type="password"
          value={formData.newPassword}
          fullWidth
          required
          onChange={handleChange}
        />
        <TextFieldWrapper
          id="confirmPassword"
          name="confirmPassword"
          label="Confirm Password"
          variant="outlined"
          type="password"
          value={formData.confirmPassword}
          fullWidth
          required
          onChange={handleChange}
        />
        <Button variant="contained" type="submit" fullWidth>
          Update Password
        </Button>
      </form>
    </Layout>
  );
};
